import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/withRouter';
import { getBoardsData } from '../../../../store/actions';
import { userAssignedBoards } from '../../../../store/selectors/userAssignedBoards';
import { baseUrlAdmin } from '../../../../store/apiConstants';
import Service from '../../../services';
import { getFormFields, isFormValid, onTextChange, onDropDownChange } from '../../../../utile/formHelper';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import LoadingComponent from '../../../loadingComponent';
import OfflineExamForm from './offlineExamForm';
import _ from 'lodash';

const offlineFieldss = require('../examForms/offline.json');
let offlineFields = _.cloneDeep(offlineFieldss);

class CreateOffline extends Component {
    constructor(props) {
        super(props);

        this.formFields = getFormFields(offlineFields, {});
        this.state = {
            exam: this.formFields.data,
            formValidations: this.formFields.formValidations,
            examTemplates: [],
            boards: [],
            classes: [],
            subjects: [],
            boardId: null,
            classId: null,
            groupId: null,
            subjectId: null,
            boardName: null,
            className: null,
            groupName: null,
            subjectName: null,
            isLoading: false,
        };
        this.service = new Service();
    }

    componentDidMount() {
        if (!this.props.boards || !this.props.boards.length) {
            this.props.getBoardsData(true);
        }
        this.getTemplates();

        if (this.props.editExamId) {
            this.setState({ isLoading: true });
            this.service.get(`${baseUrlAdmin}/examination/${this.props.editExamId}/exam-type/OfflineTest`, true).then((data) => {
                if (data && data.res && data.res.Item && data.res.Item.length) {
                    const editExam = data.res.Item[0];
                    this.setState({
                        exam: {
                            ...this.state.exam,
                            ...editExam
                        },
                        isLoading: false
                    }, () => {
                        this.formGradesDataForEdit(editExam);
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            }).catch(e => {
                this.setState({ isLoading: false });
            });
        } else if (this.props.cloneExamData && this.props.cloneExamData.examId) {
            this.setState({ isLoading: true });
            this.service.get(`${baseUrlAdmin}/examination/${this.props.cloneExamData.examId}/exam-type/OfflineTest`, true).then((data) => {
                if (data && data.res && data.res.Item && data.res.Item.length) {
                    const originalExam = data.res.Item[0];
                    const clonedExam = this.prepareCloneData(originalExam);
                    this.setState({
                        exam: {
                            ...this.state.exam,
                            ...clonedExam
                        },
                        isLoading: false
                    }, () => {
                        this.formGradesDataForEdit(originalExam);
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            }).catch(e => {
                this.setState({ isLoading: false });
            });
        }
    }

    prepareCloneData = (originalExam) => {
        // Fields to exclude from cloning
        const fieldsToExclude = [
            '_id',
            'examId',
            'createdAt',
            'updatedAt',
            'createdBy',
            'updatedBy',
            'assignedSections',
            'assignedStudents',
            'assignedSectionsOrStudents',
            'branchId',
            'assignType',
            'examResults',
            'status',
            'publishDate',
            'isPublished',
            'resultsPublished',
            'totalStudentsAssigned',
            'totalStudentsAttempted',
            'averageScore',
            'maxScore',
            'minScore',
            'lastAssignedDate',
            'lastResultGeneratedDate',
            'paperUrl',
            'answerKeyUrl',
            'answerKey',
            'exported',
            'exportMsg',
            'lastExportDate',
            'exportMsg',
            'exportStarted'
        ];

        // Create a clone of the original exam
        const clonedExam = { ...originalExam };

        // Remove unnecessary fields
        fieldsToExclude.forEach(field => {
            delete clonedExam[field];
        });

        // Keep the original exam name for cloning (user can modify if needed)
        // if (clonedExam.examName) {
        //     clonedExam.examName = `Copy of ${clonedExam.examName}`;
        // }

        // Reset dates to empty if they exist
        if (clonedExam.examStartDate) {
            clonedExam.examStartDate = '';
        }
        if (clonedExam.examEndDate) {
            clonedExam.examEndDate = '';
        }
        if (clonedExam.startTime) {
            clonedExam.startTime = '';
        }
        if (clonedExam.endTime) {
            clonedExam.endTime = '';
        }

        // Reset any status fields
        clonedExam.isDraft = true;
        clonedExam.isActive = false;

        return clonedExam;
    }

    formGradesDataForEdit = (editExam) => {
        if (this.props.boards && this.props.boards.length) {
            const _classes = [];
            const _groups = [];
            const selectedBoard = this.props.boards.find((board) => board.boardId === editExam.boardId);

            if (selectedBoard && selectedBoard.classes && selectedBoard.classes.length > 0) {
                selectedBoard.classes.map((item) => _classes.push({ className: item.className, classId: item.classId }));
            }

            const selectedClass = selectedBoard && selectedBoard.classes.find((_class) => _class.classId === editExam.classId);
            if (selectedClass && selectedClass.groups && selectedClass.groups.length > 0) {
                selectedClass.groups.map((item) => _groups.push({ groupName: item.groupName, groupId: item.groupId }));

                this.setState({
                    boardId: editExam.boardId,
                    classId: editExam.classId,
                    groupId: editExam.groupId,
                    classes: _classes,
                    groups: _groups,
                    boardName: selectedBoard.boardName,
                    className: selectedClass.className,
                }, () => {
                    this.getCurriculumData(true);
                });
            }
        }
    }

    getTemplates = () => {
        this.setState({ isLoading: true });
        const academicYear = localStorage.getItem("userAcademicYear");
        let url = `${baseUrlAdmin}/examtemplate/gettemplates?limit=1000&page=1&academicYear=${academicYear}`;

        this.service.post(url, {}, true).then((data) => {
            if (data && data.res && data.res.data && data.res.data.examTemplates.length) {
                this.setState({
                    examTemplates: data.res.data.examTemplates,
                    isLoading: false,
                });
            } else {
                this.setState({ isLoading: false });
            }
        }).catch(e => {
            this.setState({ isLoading: false });
        });
    }

    onChangeBoard = (boardId) => {
        this.setState({
            classes: [], groups: [],
            classId: null, groupId: null,
            subjects: [], subjectId: null,
        });

        const _classes = [];
        const selectedBoard = this.props.boards && this.props.boards.find((board) => board.boardId === boardId);
        if (selectedBoard && selectedBoard.classes && selectedBoard.classes.length > 0) {
            selectedBoard.classes.forEach((item) => _classes.push({ className: item.className, classId: item.classId }));
        }

        this.setState((prevState) => ({
            exam: {
                ...prevState.exam,
                boardId,
                boardName: selectedBoard.boardName,
            },
            classes: _classes,
            boardId,
            boardName: selectedBoard.boardName,
        }));
    };

    onChangeClass = (classId) => {
        this.setState({
            subjects: [], subjectId: null,
        });

        const boardId = this.state.boardId;
        const selectedBoard = this.props.boards && this.props.boards.find((board) => board.boardId === boardId);
        const selectedClass = selectedBoard.classes.find((_class) => _class.classId === classId);

        if (selectedClass && selectedClass.groups && selectedClass.groups.length > 0) {
            // Use the first group by default
            const firstGroup = selectedClass.groups[0];
            this.setState((prevState) => ({
                exam: {
                    ...prevState.exam,
                    classId,
                    className: selectedClass.className,
                    groupId: firstGroup.groupId,
                    groupName: firstGroup.groupName,
                },
                classId,
                className: selectedClass.className,
                groupId: firstGroup.groupId,
                groupName: firstGroup.groupName,
            }), () => {
                this.getCurriculumData();
            });
        }
    }

    getCurriculumData = (isEdit = false) => {
        const { boardId, classId, groupId } = this.state;
        if (boardId && classId && groupId) {
            this.setState({ isLoading: true });
            const url = `${baseUrlAdmin}/board/${boardId}/class/${classId}/group/${groupId}/active`;
            this.service.get(url, true).then((data) => {
                if (data && data.res && data.res.Item) {
                    const subjectsData = data.res.Item.subjects || [];
                    this.setState({
                        subjects: subjectsData,
                        isLoading: false,
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            }).catch(e => {
                this.setState({ isLoading: false });
            });
        } else {
            this.setState({ isLoading: false });
        }
    };

    onChangeSubject = (sId, subjectId) => {
        let selectedSubject = this.state.subjects.find((subject) => subject.subjectId == subjectId);
        let exam = this.state.exam;

        exam.subjects.forEach((s) => {
            if (s.id == sId) {
                s.subjectId = subjectId;
                s.subjectName = selectedSubject.subjectName;
            }
        });

        this.setState((prevState) => {
            return { exam };
        });
    };

    onTemplateChange = (value, fieldName, thisObj, formFields, formData, formValidations, formName, formValidationName) => {
        let data = JSON.parse(JSON.stringify(formData));
        if (value) {
            data[fieldName] = value;
            formValidations.fields[fieldName] = {
                ...formValidations.fields[fieldName],
                isValid: true,
                errorMsg: ``
            }
        } else {
            formValidations.fields[fieldName] = {
                ...formValidations.fields[fieldName],
                isValid: false,
                errorMsg: `Please select a template`
            }
        }
        thisObj.setState({
            [formName]: data,
            [formValidationName]: formValidations,
        }, () => this.getExamTemplate(value));
    }

    getExamTemplate = (templateId) => {
        this.setState({ isLoading: true });

        this.service.get(`${baseUrlAdmin}/examtemplate/getTemplateById?templateId=${templateId}`, true).then((data) => {
            if (data && data.res && data.res.data) {
                const templateData = data.res.data;
                let exam = { ...this.state.exam };

                // Set up subjects from template
                if (templateData.subjects && templateData.subjects.length > 0) {
                    exam.subjects = templateData.subjects.map((subject, index) => ({
                        id: `subject_${index + 1}`,
                        subjectId: null,
                        subjectName: null,
                        totalMarks: subject.totalMarks || 0,
                        sections: subject.sections || []
                    }));
                }

                this.setState({
                    exam,
                    isLoading: false
                });
            } else {
                this.setState({ isLoading: false });
            }
        }).catch(e => {
            this.setState({ isLoading: false });
        });
    }

    isAdditionalValid = (exam) => {
        let { formValidations } = this.state;
        let isValid = true;

        if (exam.subjects && exam.subjects.length) {
            let isSubjectNotSelected = false;
            let isDuplicateSubject = false;

            let subjectIds = [];
            exam.subjects.forEach(s => {
                if (!s.subjectId) {
                    isSubjectNotSelected = true;
                } else {
                    subjectIds.push(s.subjectId);
                }
            });

            // Check for duplicates
            const uniqueSubjectIds = [...new Set(subjectIds)];
            if (uniqueSubjectIds.length !== subjectIds.length) {
                isDuplicateSubject = true;
            }

            if (isSubjectNotSelected) {
                formValidations.fields['subjects'] = {
                    ...formValidations.fields['subjects'],
                    isValid: false,
                    errorMsg: 'Please select all subjects'
                };
                isValid = false;
            } else if (isDuplicateSubject) {
                formValidations.fields['subjects'] = {
                    ...formValidations.fields['subjects'],
                    isValid: false,
                    errorMsg: 'Duplicate subjects are not allowed'
                };
                isValid = false;
            } else {
                formValidations.fields['subjects'] = {
                    ...formValidations.fields['subjects'],
                    isValid: true,
                    errorMsg: ''
                };
            }
        }

        this.setState({ formValidations, exam });
        return isValid;
    }

    onProceed = () => {
        const { exam } = this.state;
        const formStatus = isFormValid(offlineFields, this.formFields.formValidations, exam);

        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations
            });
        } else if (!this.isAdditionalValid(exam)) {
            // Additional validation failed, errors are already set
        } else {
            this.createOfflineExam();
        }
    }

    createOfflineExam = async () => {
        const { exam } = this.state;

        try {
            this.setState({ isLoading: true });

            // Prepare exam data for offline test
            let examToSave = _.cloneDeep(exam);
            examToSave.examType = 'OfflineTest';
            examToSave.testMode = 'Offline';
            examToSave.academicYear = localStorage.getItem("userAcademicYear") || '';

            // Calculate totalMarks and totalQuestions for each subject
            examToSave.subjects = examToSave.subjects.map(subject => {
                let subjectTotalQuestions = 0;

                if (subject.sections && subject.sections.length > 0) {
                    subjectTotalQuestions = subject.sections.reduce((total, section) => {
                        return total + parseInt(section.totalQuestions || 0);
                    }, 0);
                }

                return {
                    ...subject,
                    totalQuestions: subjectTotalQuestions
                };
            });

            // Calculate total marks and total questions for the entire exam
            examToSave.totalMarks = examToSave.subjects.reduce((total, subject) => total + (subject.totalMarks || 0), 0);
            examToSave.totalNoOfQuestions = examToSave.subjects.reduce((total, subject) => total + (subject.totalQuestions || 0), 0);

            examToSave.gradeId = examToSave.classId || '';
            examToSave.gradeName = examToSave.className || '';

            if (this.props.editExamId) {
                const response = await this.service.put(
                    `${baseUrlAdmin}/examination/${this.state.exam.examId}/exam-type/OfflineTest/update-exam`,
                    examToSave,
                    true
                );

                if (response?.res?.success) {
                    this.setState({ isLoading: false });
                    this.toast.show({
                        severity: 'success',
                        summary: 'Success!',
                        detail: 'Offline exam updated successfully',
                        life: 3000
                    });
                    setTimeout(() => {
                        this.props.navigate("/TestsandExams");
                    }, 1000);
                } else {
                    throw new Error('Unable to update exam record');
                }
            } else {
                const response = await this.service.post(
                    `${baseUrlAdmin}/examination/add-exam-test`,
                    examToSave,
                    true
                );

                if (response?.res?.success) {
                    this.setState({ isLoading: false });
                    this.toast.show({
                        severity: 'success',
                        summary: 'Success!',
                        detail: 'Offline exam created successfully',
                        life: 3000
                    });
                    setTimeout(() => {
                        this.props.navigate("/TestsandExams");
                    }, 1000);
                } else {
                    throw new Error('Unable to create exam record');
                }
            }

        } catch (error) {
            this.setState({ isLoading: false });
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'An error occurred',
                life: 3000
            });
        }
    }

    render() {
        const { exam, formValidations } = this.state;

        return (
            <div className='create-offline-exam'>
                <OfflineExamForm
                    exam={exam}
                    formValidations={formValidations}
                    examTemplates={this.state.examTemplates}
                    boards={this.props.boards}
                    classes={this.state.classes}
                    subjects={this.state.subjects}
                    boardId={this.state.boardId}
                    classId={this.state.classId}
                    isEditMode={!!this.props.editExamId}
                    onTextChange={(field, value) => {
                        const { exam, formValidations } = this.state;
                        onTextChange(value, field, this, offlineFields, exam, formValidations, 'exam', 'formValidations');
                    }}
                    onDropDownChange={(field, value) => {
                        const { exam, formValidations } = this.state;
                        onDropDownChange(value, field, this, offlineFields, exam, formValidations, 'exam', 'formValidations');
                    }}
                    onTemplateChange={(value) => this.onTemplateChange(value, 'templateId', this, offlineFields, exam, formValidations, 'exam', 'formValidations')}
                    onBoardChange={this.onChangeBoard}
                    onClassChange={this.onChangeClass}
                    onSubjectChange={this.onChangeSubject}
                />

                <Toolbar className="ma-toolbard ma-mt20" right={() =>
                    <Button
                        label={this.props.editExamId ? 'Update Exam' : 'Create Exam'}
                        className='ma-m-lr10'
                        onClick={this.onProceed}
                    />
                } />

                {(this.state.isLoading || this.props.isLoading) && <LoadingComponent />}
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        boards: userAssignedBoards(state, 'activeBoards'),
        isLoading: state.boardsData.loading,
    };
};

export default connect(mapStateToProps, { getBoardsData })(withRouter(CreateOffline));